import React, { useEffect, useRef, useState } from 'react';
import { Fade } from 'react-awesome-reveal';

const TestimonialSection = () => {
  const carouselRef = useRef(null);
  const [carouselReady, setCarouselReady] = useState(false);
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    let timeoutId;
    let cleanupFunction;

    const initCarousel = () => {
      // Check if jQuery and Owl Carousel are available
      if (!window.jQuery || !window.$.fn || !window.$.fn.owlCarousel) {
        console.log('Carousel dependencies not loaded');
        timeoutId = setTimeout(initCarousel, 500);
        return;
      }

      const $ = window.$;
      const $carousel = $(carouselRef.current);

      // Destroy existing carousel if any
      if ($carousel.data('owl.carousel')) {
        $carousel.trigger('destroy.owl.carousel');
        $carousel.removeClass('owl-loaded owl-drag owl-grab');
      }

      try {
        $carousel.owlCarousel({
          autoplay: true,
          autoplayTimeout: 3000,
          autoplayHoverPause: true,
          smartSpeed: 800,
          margin: 25,
          loop: true,
          center: false,
          dots: true,
          nav: true,
          navText: [
            '<i class="fa fa-chevron-left"></i>',
            '<i class="fa fa-chevron-right"></i>'
          ],
          responsive: {
            0: { 
              items: 1,
              margin: 15,
              stagePadding: 15
            },
            576: { 
              items: 1,
              margin: 20
            },
            768: { 
              items: 2,
              margin: 20
            },
            992: { 
              items: 3,
              margin: 25
            }
          }
        });

        setCarouselReady(true);
        setShowFallback(false);

        cleanupFunction = () => {
          if ($carousel.data('owl.carousel')) {
            $carousel.trigger('destroy.owl.carousel');
          }
        };
      } catch (error) {
        console.error('Error initializing carousel:', error);
        setShowFallback(true);
      }
    };

    // Start initialization
    timeoutId = setTimeout(initCarousel, 100);

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      if (cleanupFunction) cleanupFunction();
    };
  }, []);

  const testimonials = [
  { 
    id: 1, 
    image: '/img/testimonial-1.jpg', 
    name: 'Rahul Sharma', 
    profession: 'Corporate Client', 
    text: 'New Galaxy Interiors handled our office fit-out from design to execution flawlessly. The workspace is functional, modern, and delivered exactly on schedule.' 
  },
  { 
    id: 2, 
    image: '/img/testimonial-2.jpg', 
    name: 'Priya Patel', 
    profession: 'Office Manager', 
    text: 'The office renovation completely transformed our workplace. From planning to installation, the team was professional, responsive, and detail-oriented.' 
  },
  { 
    id: 3, 
    image: '/img/testimonial-3.jpg', 
    name: 'Amit Verma', 
    profession: 'Business Owner', 
    text: 'They delivered a full design and build solution for our commercial space. Excellent workmanship, smart layouts, and seamless coordination throughout the project.' 
  },
  { 
    id: 4, 
    image: '/img/testimonial-4.jpg', 
    name: 'Neha Gupta', 
    profession: 'Showroom Director', 
    text: 'Outstanding commercial fit-out and installation work. They understood our brand requirements and executed the project with precision and quality.' 
  }
];


  return (
    <div className="testimonial-section container-xxl bg-light my-6 py-6 pb-0">
      <div className="container">
        <Fade triggerOnce>
          <div className="text-center mx-auto mb-5" style={{ maxWidth: '500px' }}>
            <p className="text-primarys text-uppercase mb-2">// Client's Review</p>
            <h1 className="display-6 mb-4">More Than 1000+ Customers Trusted Us</h1>
          </div>
        </Fade>

        {/* Carousel Container */}
        <div style={{ minHeight: '300px', position: 'relative' }}>
          {/* Loading State */}
          {!carouselReady && !showFallback && (
            <div className="text-center py-5">
              <div className="spinner-border text-primarys" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3">Loading testimonials...</p>
            </div>
          )}

          {/* Owl Carousel */}
          <div 
            ref={carouselRef} 
            className="owl-carousel testimonial-carousel"
            style={{ 
              display: carouselReady ? 'block' : 'none',
              opacity: carouselReady ? 1 : 0,
              transition: 'opacity 0.3s ease'
            }}
          >
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-item bg-white rounded p-4 h-100">
                <div className="d-flex align-items-center mb-4">
                  <div className="flex-shrink-0">
                    <img 
                      className="rounded-circle border p-1" 
                      src={testimonial.image} 
                      alt={testimonial.name}
                      style={{ width: '70px', height: '70px', objectFit: 'cover' }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(testimonial.name)}&background=628141&color=fff&size=70`;
                      }}
                    />
                  </div>
                  <div className="ms-4">
                    <h5 className="mb-1">{testimonial.name}</h5>
                    <span className="text-primarys">{testimonial.profession}</span>
                  </div>
                </div>
                <p className="mb-0">{testimonial.text}</p>
              </div>
            ))}
          </div>

          {/* Fallback Grid if Carousel Fails */}
          {showFallback && (
            <Fade triggerOnce>
              <div className="row g-4">
                {testimonials.map((testimonial) => (
                  <div key={testimonial.id} className="col-12 col-md-6 col-lg-3">
                    <div className="testimonial-item bg-white rounded p-4 h-100">
                      <div className="d-flex align-items-center mb-4">
                        <div className="flex-shrink-0">
                          <img 
                            className="rounded-circle border p-1" 
                            src={testimonial.image} 
                            alt={testimonial.name}
                            style={{ width: '70px', height: '70px', objectFit: 'cover' }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(testimonial.name)}&background=628141&color=fff&size=70`;
                            }}
                          />
                        </div>
                        <div className="ms-4">
                          <h5 className="mb-1">{testimonial.name}</h5>
                          <span className="text-primarys">{testimonial.profession}</span>
                        </div>
                      </div>
                      <p className="mb-0">{testimonial.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Fade>
          )}
        </div>

        <Fade triggerOnce>
          <div className="bg-call text-light rounded p-5 my-6 mb-0">
            <div className="row align-items-center">
              <div className="col-md-6">
                <h1 className="display-4 text-light mb-0">Subscribe Our Newsletter</h1>
              </div>
              <div className="col-md-6 text-md-end">
                <div className="position-relative">
                  <input 
                    className="form-control bg-transparent border-light w-100 py-3 ps-4 pe-5" 
                    type="email" 
                    placeholder="Your email" 
                    aria-label="Email address"
                  />
                  <button 
                    type="button" 
                    className="btn btn-dark py-2 px-3 position-absolute top-0 end-0 mt-2 me-2"
                  >
                    SignUp
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default TestimonialSection;

